import { Injectable } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmConfig } from '@shared/components/confirm/confirm-config.model';
import { ConfirmComponent } from '@shared/components/confirm/confirm.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmService {
  constructor(public dialogService: DialogService) {}

  public confirm(confirmConfig: ConfirmConfig): void {
    const ref = this.dialogService.open(ConfirmComponent, { data: confirmConfig });

    ref.onClose.subscribe((result: any) => {
      if (result.value) {
        confirmConfig.accept(result.value);
      } else {
        if (result.accept) {
          confirmConfig.accept();
        } else if (confirmConfig.reject) {
          confirmConfig.reject();
        }
      }
    });
  }
}
